import {
  TechemModal,
  TechemModalBody,
  TechemModalButtonFooter,
  TechemModalHeader
} from '@techem/ui-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TOSContent } from '../../../../components/shared/TOSContent';
import { TrackerUtil } from '../../../../../tracking/TrackerUtil';

interface TermsAndConditionModalProps {
  TOSModalOpen: boolean;
  setTOSModalOpen: (error: boolean) => void;
}

const TermsAndConditionModal: FC<TermsAndConditionModalProps> = ({
  TOSModalOpen,
  setTOSModalOpen
}) => {
  const { t } = useTranslation();

  return (
    <TechemModal
      closeable
      autoFocus={false} // set to false to prevent automatic scrolling to cta
      isOpen={TOSModalOpen}
      modalTrackingId="modal-agb"
      additionalTestId="agb"
      onClose={() => {
        setTOSModalOpen(false);
      }}
      header={<TechemModalHeader titleAlignment="start" title={t('breadcrumbTOS')} />}
      body={
        <TechemModalBody>
          <TOSContent />
        </TechemModalBody>
      }
      footer={
        <TechemModalButtonFooter
          primary={{
            text: t('closeModalText'),
            handleOnClick: () => setTOSModalOpen(false),
            additionalTestId: 'close'
          }}
          trackClickUsingTestId={(buttonIdentifier) =>
            TrackerUtil.trackBtnClickByIdentifier(buttonIdentifier, 'modal-agb')
          }
        />
      }
    />
  );
};

export default TermsAndConditionModal;
